module.exports = __webpack_public_path__ + "img/img_039@2x.a6226e23.png";